import ButtonField from '../buttonField/buttonField';
import { ButtonFieldProps } from '../buttonField/types/buttonFieldProps';
import { classNameBtn, iconPosition } from '../shared/button/types/buttonProps';
import Label from '../shared/label/label';
import { labelProps } from "../shared/label/types/labelProps";
import { stylizationVerticalAlign } from '../shared/stylization';
import './toggleButton.scss';
import { ToggleButtonProps } from './types/toggleButtonProps';

const ToggleButton = (props: ToggleButtonProps) => {
    // Button toggle
    const getBtnToggleProps = (title: string, icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | undefined,
        onClick: React.MouseEventHandler<HTMLButtonElement>, isOff: boolean): ButtonFieldProps => {
        let className = classNameBtn.Small + " body-txt-medium";
        if (isOff) className = className + " offButton";

        var dataProps: ButtonFieldProps = {
            BtnProps: {
                onClick: onClick,
                style: {
                    width: '100%',
                    height: '45px'
                },
                className: className
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
        };
        if (icon) {
            dataProps.additionalIcon = icon;
            dataProps.iconPosition = iconPosition.Start;
        }
        return dataProps;
    }

    const handleLeftClick = () => {
        props.onChangeLeft();
        props.setBtnToggle(!props.btnToggle);
    }

    const handleRightClick = () => {
        props.onChangeRight();
        props.setBtnToggle(!props.btnToggle);
    }

    var labelProps: labelProps = {
        style: {
            marginBottom: '10px',
            display: "inline-block"
        }
    }

    return (
        <div style={props.style}>
            {props.label && <Label {...labelProps} className='body-txt-medium' labelname={props.label}></Label>}
            <div className="toggle-button-wrapper">
                <ButtonField {...getBtnToggleProps(props.leftText, props.leftIcon, handleLeftClick, !props.btnToggle)} />
                <ButtonField {...getBtnToggleProps(props.rightText, props.rightIcon, handleRightClick, props.btnToggle)} />
            </div>
        </div>   
    )
}

export default ToggleButton;
